export const INVENTORY_SCROLL_TO_TOP_ANCHOR = 'inventory-scroll-to-top';
